import { DisplayTransactionType } from '@features/bankTransactions/enums/displayTransactionType'
import { TransactionType } from '@features/bankTransactions/enums/transactionType'
import { OpenBankingTransactionType } from '@features/openBanking/enums/openBankingTransactionType'

import { Side } from '../../../../../../../enums/side'
import { openBankingTransactionTypeMap } from '../constants/openBankingTransactionTypeMap'
import { transactionTypeToDisplayType } from '../constants/transactionTypeToDisplayType'

export const formatTransactionType = (type: string, side: Side): DisplayTransactionType => {
  const openBankingMapper = openBankingTransactionTypeMap[type as OpenBankingTransactionType]
  if (openBankingMapper) {
    return openBankingMapper(side)
  }

  const bankAccountMapper = transactionTypeToDisplayType[type as TransactionType]
  if (bankAccountMapper) {
    return bankAccountMapper(side)
  }

  return DisplayTransactionType.Unknown
}
